export const LOADING_START = 'LOADING_START';
export const LOADING_COMPLETE = 'LOADING_COMPLETE';
